import { useEffect, useRef, useState } from 'react';

interface UseIntersectionObserverOptions {
	root?: Element | null;
	rootMargin?: string;
	threshold?: number | number[];
	triggerOnce?: boolean;
}

export const useIntersectionObserver = (
	options: UseIntersectionObserverOptions = {}
) => {
	const [isIntersecting, setIsIntersecting] = useState(false);
	const [hasIntersected, setHasIntersected] = useState(false);
	const elementRef = useRef<HTMLAnchorElement | null>(null);

	useEffect(() => {
		const element = elementRef.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				const isIntersecting = entry.isIntersecting;
				setIsIntersecting(isIntersecting);
				
				if (isIntersecting && options.triggerOnce && !hasIntersected) {
					setHasIntersected(true);
				}
			},
			{
				root: options.root || null,
				rootMargin: options.rootMargin || '0px',
				threshold: options.threshold || 0,
			}
		);

		observer.observe(element);

		return () => {
			observer.unobserve(element);
		};
	}, [options.root, options.rootMargin, options.threshold, options.triggerOnce, hasIntersected]);

	return { elementRef, isIntersecting, hasIntersected };
}; 